import { GROUPED_PRIVILEGES } from '@/entities/authentication';
import { privilegeGuardRoute } from '@/features/authenticate';
import { CreateEventPage } from '@/pages/events';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_private/events/create')({
  beforeLoad: () =>
    privilegeGuardRoute({ privileges: GROUPED_PRIVILEGES.eventCreate }),
  component: CreateEventPage,
});
